import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function surveyFeedbackDetailsReportReducer(
  state: ReportDto = initialState.surveyFeedbackDetailsReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_SURVEY_FEEDBACK_DETAILS_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
